import {formatLocalDateTime} from "./adminDateFormat";
import {normalizeEnumKey} from "../../i18n/labelHelpers";
import type {StatusTone} from "../../Components/ui/StatusTag";

export type NotificationHistoryVariables = {
    eventId: number;
    take: number;
    skip: number;
};

export const parsePositiveIntParam = (value: string | null): number | undefined => {
    if (!value) {
        return undefined;
    }

    const parsed = Number(value);
    if (!Number.isInteger(parsed) || parsed <= 0) {
        return undefined;
    }

    return parsed;
};

export const buildNotificationHistoryVariables = (
    eventId: number,
    take: number,
    skip: number
): NotificationHistoryVariables => ({
    eventId,
    take,
    skip
});

export const notificationStatusTone = (status?: string | null): StatusTone => {
    switch (normalizeEnumKey(status)) {
    case "SENT":
        return "success";
    case "FAILED":
        return "error";
    case "DRAFT":
        return "warning";
    default:
        return "neutral";
    }
};

const technicalNotificationFailurePatterns = [
    /smtp/i,
    /socket/i,
    /timeout/i,
    /timed out/i,
    /ssl/i,
    /tls/i,
    /authentication/i,
    /connection/i,
    /refused/i,
    /mailbox unavailable/i,
    /host unreachable/i
];

export const sanitizeNotificationFailureMessage = (
    value?: string | null,
    fallback = "Email delivery failed."
) => {
    const message = value?.trim() ?? "";
    if (!message) {
        return "";
    }

    return technicalNotificationFailurePatterns.some(pattern => pattern.test(message))
        ? fallback
        : message;
};

export const stripHtmlForPreview = (value?: string | null) =>
    (value ?? "")
        .replace(/<[^>]+>/g, " ")
        .replace(/&nbsp;/gi, " ")
        .replace(/\s+/g, " ")
        .trim();

export const formatNotificationTimestamp = (value?: string | null) => {
    return formatLocalDateTime(value);
};
